/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconChangelog = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 22 22"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 22px;
      `}
      {...props}
    >
      <g fill={fill} fillRule="evenodd">
        <path
          stroke={stroke}
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M11 3.143l7.857 15.714H3.143z"
        />
        <circle cx={11} cy={3.143} r={3.143} fill="currentColor" />
        <circle cx={18.857} cy={18.857} r={3.143} fill="currentColor" />
        <circle cx={3.143} cy={18.857} r={3.143} fill="currentColor" />
      </g>
    </svg>
  ),
);
